import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  Icon,
  Button,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import { useStyles } from "./styles";
import { SECCIONES } from "./helper";
import logo_cuc from "../../global/imagenes/logo_cuc2.png";
import avatar from "../../global/imagenes/account.png";
import foto_lines from "../../global/imagenes/proyecto_vida/oportunidades_lines.png";

// Mezcla un color hex con blanco para obtener un tono más claro (0..1)
const aclarar = (hex, factor = 0.82) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  const mez = (c) => Math.round(c + (255 - c) * factor);
  return `rgb(${mez(r)}, ${mez(g)}, ${mez(b)})`;
};

export default function ProyectoVidaDetalle({
  datos,
  usuario,
  programas,
  versiones,
  versionSeleccionada,
  onCambiarVersion,
  onEditar,
  mostrarAcciones,
  mostrarEditar,
  fotoBase64,
  fotoLocal,
}) {
  const classes = useStyles();

  const nombreCompleto = usuario
    ? [usuario.primer_nombre, usuario.primer_apellido, usuario.segundo_apellido]
      .filter(Boolean)
      .join(" ")
    : "";

  const fotoBruta = fotoBase64 || (fotoLocal ? localStorage.getItem("fotoMs") : null);
  const fotoValida = fotoBruta && fotoBruta !== "null" && fotoBruta !== "undefined";
  const fotoSrc = fotoValida ? `data:image/png;base64,${fotoBruta}` : avatar;

  const nombresProgramas = (programas || [])
    .map((p) => (p && p.relacion ? p.relacion.nombre : null))
    .filter(Boolean);

  const renderProgramas = () => {
    if (nombresProgramas.length === 0) {
      return <Typography className={classes.programas}>Estudiante</Typography>;
    }
    if (nombresProgramas.length === 1) {
      return <Typography className={classes.programas}>Estudiante de {nombresProgramas[0]}</Typography>;
    }
    return (
      <div>
        <Typography className={classes.programas}>Estudiante de:</Typography>
        <ul style={{ margin: "6px 0 0 0", paddingLeft: 18, textAlign: "left" }}>
          {nombresProgramas.map((n, i) => (
            <li key={i} className={classes.programas}>
              {n}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const renderCard = (seccion) => (
    <Grid item xs={12} sm={6} md={4} key={seccion.key}>
      <div className={classes.card}>
        {/* Burbuja con el logo (fondo del color de la sección, más claro) */}
        <div className={classes.burbuja} style={{ backgroundColor: aclarar(seccion.color) }}>
          <img src={seccion.logo} alt={seccion.titulo} style={{ width: 65, height: 65, objectFit: "contain" }} />
        </div>

        {/* Título */}
        <Typography variant="subtitle1" className={classes.tituloSeccion} style={{ color: seccion.color }}>
          {seccion.titulo}
        </Typography>
        <div className={classes.divisorSeccion} style={{ backgroundColor: seccion.color }} />

        {/* Texto del estudiante */}
        <Typography className={classes.textoSeccion}>{datos ? datos[seccion.key] : ""}</Typography>

        {/* Ola decorativa inferior (imagen a ancho completo, anclada al fondo) */}
        <img src={seccion.cardDetail} alt="" className={classes.ola} />
      </div>
    </Grid>
  );

  return (
    <div style={{ padding: "20px 28px 60px 28px" }}>
      {/* Barra superior: select de versiones + botón editar */}
      {mostrarAcciones && (
        <div className={classes.barraSuperior}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 220, backgroundColor: "#fff" }}>
            <Select
              value={versionSeleccionada || ""}
              onChange={(e) => onCambiarVersion && onCambiarVersion(e.target.value)}
              displayEmpty
            >
              {(versiones || []).map((v) => (
                <MenuItem key={v.value} value={v.value}>
                  {v.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {mostrarEditar && (
            <Button variant="contained" className={classes.btnEditar} onClick={() => onEditar && onEditar()} startIcon={<Icon>edit</Icon>}>
              Actualizar
            </Button>
          )}
        </div>
      )}

      <div className={classes.poster}>
        {/* Columna izquierda: datos del estudiante */}
        <div className={classes.panelIzq}>
          <div className={classes.fotoWrapper}>
            <img src={fotoSrc} alt={nombreCompleto} className={classes.foto} />
            <img src={foto_lines} alt="" className={classes.fotoLines} />
          </div>

          <Typography className={classes.nombre}>{nombreCompleto}</Typography>
          <div className={classes.divisor} />
          {renderProgramas()}

          <div className={classes.fraseWrapper}>
            <Icon className={classes.fraseIcono}>format_quote</Icon>
            <Typography className={classes.frase}>{datos ? datos.frase : ""}</Typography>
          </div>

          <img src={logo_cuc} alt="Universidad de la Costa CUC" style={{ width: 150, objectFit: "contain", marginTop: "auto" }} />
        </div>

        {/* Columna derecha: las 6 secciones */}
        <div style={{ flex: 1, minWidth: 320 }}>
          <Grid container spacing={3}>
            {SECCIONES.map((seccion) => renderCard(seccion))}
          </Grid>
        </div>
      </div>
    </div>
  );
}

ProyectoVidaDetalle.propTypes = {
  datos: PropTypes.object,
  usuario: PropTypes.object,
  programas: PropTypes.array,
  versiones: PropTypes.array,
  versionSeleccionada: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCambiarVersion: PropTypes.func,
  onEditar: PropTypes.func,
  mostrarAcciones: PropTypes.bool,
  mostrarEditar: PropTypes.bool,
  fotoBase64: PropTypes.string,
  fotoLocal: PropTypes.bool,
};

ProyectoVidaDetalle.defaultProps = {
  mostrarAcciones: true,
  mostrarEditar: true,
  fotoLocal: true,
};
